import React from 'react';
import { Outlet } from 'react-router-dom';
import ReleaseIdCardProvider from './context/state';

const ReleaseIdCardComponent = (): React.ReactElement => {
  return (
    <>
      <ReleaseIdCardProvider>
        <Outlet />
      </ReleaseIdCardProvider>
    </>
  );
};

ReleaseIdCardComponent.displayName = 'Release Id Card root component';
export default ReleaseIdCardComponent;
